import { render, staticRenderFns } from "./anchorScrollNav.vue?vue&type=template&id=ed9d3e56"
import script from "./anchorScrollNav.vue?vue&type=script&lang=js"
export * from "./anchorScrollNav.vue?vue&type=script&lang=js"
import style0 from "./anchorScrollNav.vue?vue&type=style&index=0&id=ed9d3e56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports